<template>
        <div class="diagrams">
            <h1 id="diagram_title">The results of the survey of respondents of COVID resistance</h1>

            <!-- first -->
            <section class="pie_section" id="first_pie">
                <div class="info_pie">
                    <h2>Age(вік)</h2>
                    <br>
                    <p>2213 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie1"></div>
            </section>
            <div id="pie_desc1" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        <p>0-15</p>
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        16-22
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        23-40
                    </div>
                </div>
                <div class="round green_circle">
                    <div class="text_desc">
                        40-65
                    </div>
                </div>
                <div class="round purple_circle">
                    <div class="text_desc">
                        >65
                    </div>
                </div>
            </div>

            <!-- second -->
            <section class="pie_section" id="second_pie">
                <div class="info_pie">
                    <h2>Gender(стать)</h2>
                    <br>
                    <p>2210 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie2"></div>
            </section>
            <div id="pie_desc2" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        Male(Чоловік)
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        Female(Жінка)
                    </div>
                </div>
            </div>

            <!-- third -->
            <section class="pie_section" id="third_pie">
                <div class="info_pie">
                    <h2>Region(регіон)</h2>
                    <br>
                    <p>2193 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie3"></div>
            </section>
            <div id="pie_desc3" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        Ukraine, Lviv(Львів)
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        Ukraine, Chernivtsi <br> (Чернівці)
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        Belarus(Білорусь)
                    </div>
                </div>
                <div class="round green_circle">
                    <div class="text_desc">
                        Germany(Німеччина)
                    </div>
                </div>
                <div class="round purple_circle">
                    <div class="text_desc">
                        Others(Інші)
                    </div>
                </div>
            </div>

            <!-- fourth -->
            <section class="pie_section" id="forth_pie">
                <div class="info_pie">
                    <h2>Have you had Covid'19 this year?(Чи хворіли Ви на Covid'19 цього року)</h2>
                    <br>
                    <p>2211 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie4"></div>
            </section>
            <div id="pie_desc4" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        Yes
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        No
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        Maybe(можливо)
                    </div>
                </div>
            </div>

            <!-- fifth -->
            <section class="pie_section" id="fifth_pie">
                <div class="info_pie">
                    <h2>IgG level(Рівень імуноглобіна IgG, якщо відомо)</h2>
                    <br>
                    <p>1843 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie5"></div>
            </section>
            <div id="pie_desc5" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        <p>
                            &#60;0.9 <br> (negative/негативний)
                        </p>
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        0.9-1.1(indefinable/ <br> невизначений)
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        &#62;1.1 <br> (positive/позитивний)
                    </div>
                </div>
            </div>

            <!-- sixth -->
            <section class="pie_section" id="sixth_pie">
                <div class="info_pie">
                    <h2>IgM level(Рівень імуноглобіна IgM, якщо відомо)</h2>
                    <br>
                    <p>1820 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie6"></div>
            </section>
            <div id="pie_desc6" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        <p>
                            &#60;0.9 <br> (negative/негативний)
                        </p>
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        0.9-1.1(indefinable/ <br> невизначений)
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        &#62;1.1 <br> (positive/позитивний)
                    </div>
                </div>
            </div>

            <!-- seventh -->
            <section class="pie_section" id="seventh_pie">
                <div class="info_pie">
                    <h2>Blood group(Група крові)</h2>
                    <br>
                    <p>2176 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie7"></div>
            </section>
            <div id="pie_desc7" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        <p>
                            1
                        </p>
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        2
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        3
                    </div>
                </div>
                <div class="round green_circle">
                    <div class="text_desc">
                        4
                    </div>
                </div>
            </div>

            <!-- eighth -->
            <section class="pie_section" id="eighth_pie">
                <div class="info_pie">
                    <h2>Do you vaccinated influenza?(Ви вакциновані від грипу?)</h2>
                    <br>
                    <p>2203 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie8"></div>
            </section>
            <div id="pie_desc8" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        Yes
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        No
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        Maybe(можливо)
                    </div>
                </div>
            </div>

            <!-- nineth -->
            <section class="pie_section" id="nineth_pie">
                <div class="info_pie">
                    <h2>Do you vaccinated tuberculosis?(Ви вакциновані від туберкульозу?)</h2>
                    <br>
                    <p>2209 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie9"></div>
            </section>
            <div id="pie_desc9" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        Yes
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        No
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        Maybe(можливо)
                    </div>
                </div>
            </div>

            <!-- tenth -->
            <section class="pie_section" id="tenth_pie">
                <div class="info_pie">
                    <h2>Have you had influenza this year?(Чи хоріли грипом Ви цього року?)</h2>
                    <br>
                    <p>2209 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie10"></div>
            </section>
            <div id="pie_desc10" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        Yes
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        No
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        Maybe(можливо)
                    </div>
                </div>
            </div>

            <!-- eleventh -->
            <section class="pie_section" id="eleventh_pie">
                <div class="info_pie">
                    <h2>Have you had tuberculosis this year?(Чи хворіли Ви туберкульозом цього року?)</h2>
                    <br>
                    <p>2208 answers(відповідей)</p>
                </div>
                <div class="piechart" id="pie11"></div>
            </section>
            <div id="pie_desc11" class="desc">
                <div class="round blue_circle">
                    <div class="text_desc">
                        Yes
                    </div>
                </div>
                <div class="round red_circle">
                    <div class="text_desc">
                        No
                    </div>
                </div>
                <div class="round orange_circle">
                    <div class="text_desc">
                        Maybe(можливо)
                    </div>
                </div>
            </div>
        </div>

</template>

<script>
export default {
  name: 'Diagrams',
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.diagrams {
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 10% (minmax(10px, 1fr))[10] 10%;
      grid-template-columns: 10% repeat(10, minmax(10px, 1fr)) 10%;
  -ms-grid-rows: 2fr 6fr 6fr 6fr;
      grid-template-rows: 2fr 6fr 6fr 6fr;
  background-color: #1d1d1d;
  color: white;
  padding-bottom: 200px;
}

#diagram_title {
  -ms-grid-column: 2;
  -ms-grid-column-span: 10;
  grid-column: 2/12;
  -ms-grid-row: 1;
  -ms-grid-row-span: 1;
  grid-row: 1/2;
  text-align: center;
}

.piechart {
  padding-right: 100px;
  display: block;
  width: 250px;
  height: 250px;
  border-radius: 50%;
  border: 6px black solid;
  margin-left: 100px;
}

.round {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 40px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.text_desc {
  font-size: 24px;
  margin-left: 50px;
  white-space: nowrap;
}

.red_circle {
  background-color: #BF211E;
}

.blue_circle {
  background-color: #003249;
}

.orange_circle {
  background-color: #FC9E4F;
}

.green_circle {
  background-color: #8FE388;
}

.purple_circle {
  background-color: #7D7ABC;
}

.info_pie {
  padding-bottom: 50px;
}

.pie_section {
  margin-bottom: 100px;
}

.desc {
  margin-bottom: 100px;
}

#first_pie {
  -ms-grid-row: 2;
  -ms-grid-row-span: 1;
  grid-row: 2/3;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie_desc1 {
  margin-top: 20px;
  -ms-grid-row: 2;
  -ms-grid-row-span: 1;
  grid-row: 2/3;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#pie1 {
  background-image: conic-gradient(#8FE388 32.5%, #BF211E 0 57.9%, #FC9E4F 0 93.3%, #7D7ABC 0 98.8%, #003249 0);
}

#second_pie {
  -ms-grid-row: 3;
  -ms-grid-row-span: 1;
  grid-row: 3/4;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie_desc2 {
  margin-top: 20px;
  -ms-grid-row: 3;
  -ms-grid-row-span: 1;
  grid-row: 3/4;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#pie2 {
  background-image: conic-gradient(#BF211E 54.3%, #003249 0);
}

#third_pie {
  -ms-grid-row: 4;
  -ms-grid-row-span: 1;
  grid-row: 4/5;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie3 {
  background-image: conic-gradient(#003249 90.7%, #BF211E 0 92.7%, #8FE388 0 93.7%, #FC9E4F 0 93.8%, #7D7ABC 0);
}

#pie_desc3 {
  margin-top: 20px;
  -ms-grid-row: 4;
  -ms-grid-row-span: 1;
  grid-row: 4/5;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#forth_pie {
  -ms-grid-row: 5;
  -ms-grid-row-span: 1;
  grid-row: 5/6;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie4 {
  background-image: conic-gradient(#BF211E 56.1%, #003249 0 83.8%, #FC9E4F 0);
}

#pie_desc4 {
  margin-top: 20px;
  -ms-grid-row: 5;
  -ms-grid-row-span: 1;
  grid-row: 5/6;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#fifth_pie {
  -ms-grid-row: 6;
  -ms-grid-row-span: 1;
  grid-row: 6/7;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie5 {
  background-image: conic-gradient(#003249 78.6%, #FC9E4F 0 99%, #BF211E 0);
}

#pie_desc5 {
  margin-top: 20px;
  -ms-grid-row: 6;
  -ms-grid-row-span: 1;
  grid-row: 6/7;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#sixth_pie {
  -ms-grid-row: 7;
  -ms-grid-row-span: 1;
  grid-row: 7/8;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie6 {
  background-image: conic-gradient(#003249 76%, #FC9E4F 0 99.6%, #BF211E 0);
}

#pie_desc6 {
  margin-top: 20px;
  -ms-grid-row: 7;
  -ms-grid-row-span: 1;
  grid-row: 7/8;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#seventh_pie {
  -ms-grid-row: 8;
  -ms-grid-row-span: 1;
  grid-row: 8/9;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie7 {
  background-image: conic-gradient(#BF211E 42.8%, #FC9E4F 0 58.1%, #003249 0 92.6%, #8FE388 0);
}

#pie_desc7 {
  margin-top: 20px;
  -ms-grid-row: 8;
  -ms-grid-row-span: 1;
  grid-row: 8/9;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#eighth_pie {
  -ms-grid-row: 9;
  -ms-grid-row-span: 1;
  grid-row: 9/10;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie8 {
  background-image: conic-gradient(#BF211E 81.6%, #003249 0 97.1%, #FC9E4F 0);
}

#pie_desc8 {
  margin-top: 20px;
  -ms-grid-row: 9;
  -ms-grid-row-span: 1;
  grid-row: 9/10;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#nineth_pie {
  -ms-grid-row: 10;
  -ms-grid-row-span: 1;
  grid-row: 10/11;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie9 {
  background-image: conic-gradient(#003249 77.3%, #FC9E4F 0 84.7%, #BF211E 0);
}

#pie_desc9 {
  margin-top: 20px;
  -ms-grid-row: 10;
  -ms-grid-row-span: 1;
  grid-row: 10/11;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#tenth_pie {
  -ms-grid-row: 11;
  -ms-grid-row-span: 1;
  grid-row: 11/12;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie10 {
  background-image: conic-gradient(#BF211E 72%, #FC9E4F 0 82.7%, #003249 0);
}

#pie_desc10 {
  margin-top: 20px;
  -ms-grid-row: 11;
  -ms-grid-row-span: 1;
  grid-row: 11/12;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

#eleventh_pie {
  -ms-grid-row: 12;
  -ms-grid-row-span: 1;
  grid-row: 12/13;
  -ms-grid-column: 2;
  -ms-grid-column-span: 8;
  grid-column: 2/10;
}

#pie11 {
  background-image: conic-gradient(#BF211E 99.7%, #003249 0);
}

#pie_desc11 {
  margin-top: 20px;
  -ms-grid-row: 12;
  -ms-grid-row-span: 1;
  grid-row: 12/13;
  -ms-grid-column: 10;
  -ms-grid-column-span: 3;
  grid-column: 10/13;
}

@media only screen and (max-width: 415px) {
  #diagram_title {
    font-size: 24px;
  }
  .diagrams {
    display: block;
    padding-bottom: 100px;
  }
  .info_pie {
    margin-left: 20px;
  }
  .piechart {
    padding-right: 0px;
    margin-left: 50px;
  }
  #diagram_title {
    margin-bottom: 100px;
  }
  .desc {
    margin-bottom: 120px;
  }
}

@media only screen and (min-width: 415px) and (max-width: 1400px) {
  .diagrams {
    display: block;
    padding-bottom: 100px;
  }
  .info_pie {
    margin-left: 30px;
  }
  .piechart {
    padding-right: 0px;
    margin-left: 140px;
  }
  #diagram_title {
    margin-bottom: 100px;
  }
  .desc {
    margin-left: 50px;
    margin-bottom: 120px;
  }
}
</style>
